const enc = new TextEncoder();
const dec = new TextDecoder();
const ITER = 250000;

const b64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let s = "";
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(s);
};
const unb64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));

async function deriveKey(password, salt) {
  const base = await crypto.subtle.importKey("raw", enc.encode(password), "PBKDF2", false, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt, iterations: ITER, hash: "SHA-256" },
    base, { name: "AES-GCM", length: 256 }, false, ["encrypt", "decrypt"]
  );
}

export async function encryptJson(obj, password) {
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const key = await deriveKey(password, salt);
  const ct = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, enc.encode(JSON.stringify(obj)));
  return { ciphertext: b64(ct), salt: b64(salt), iv: b64(iv) };
}

export async function decryptJson({ ciphertext, salt, iv }, password) {
  const key = await deriveKey(password, unb64(salt));
  const pt = await crypto.subtle.decrypt({ name: "AES-GCM", iv: unb64(iv) }, key, unb64(ciphertext));
  return JSON.parse(dec.decode(pt));
}

export function generatePassword() {
  const words = "amber coral delta ember frost grove harbor ivory jade lotus maple nectar orbit pearl quartz river sage tide umber velvet willow zephyr".split(" ");
  const r = crypto.getRandomValues(new Uint32Array(4));
  return `${words[r[0] % words.length]}-${words[r[1] % words.length]}-${words[r[2] % words.length]}-${r[3] % 1000}`;
}

export function formatBytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}
